import React from 'react';
import { motion } from 'framer-motion';
import { pageData } from './data';
export function PainPoints() {
  const {
    painPoints
  } = pageData;
  return <section className="py-20 px-4 bg-navy-900 border-y border-white/5" data-id="element-135">
      <div className="max-w-5xl mx-auto" data-id="element-136">
        <div className="text-center mb-16" data-id="element-137">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl mb-6" data-id="element-138">
            {painPoints.heading}
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-slate-400 max-w-2xl mx-auto" data-id="element-139">
            {painPoints.intro}
          </motion.p>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-140">
          {painPoints.items.map((item, idx) => {
          return <motion.div key={idx} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className="bg-slate-850 border border-slate-800 rounded-2xl p-8 hover:border-white/10 transition-colors" data-id="element-141">
                <div className="text-4xl leading-none mb-5 select-none" role="img" aria-label={item.title} data-id="element-142">
                  {item.emoji}
                </div>
                <h3 className="text-xl mb-2 text-white" data-id="element-143">{item.title}</h3>
                <p className="text-slate-400 leading-relaxed" data-id="element-144">
                  {item.description}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}